/**
 * Shared menu configuration for GSD Tools
 * This configuration is used by both Home.js and NavigationMenu.js
 * Edit items here to have changes reflected in both places
 */

import IntercomIcon from "../assets/intercom_icon_198119.png";
import Auth0UnlockIcon from "../assets/auth0_unlock_icon.svg";

export const getMenuConfiguration = (
  permissions,
  sendgridpermissions,
  dashboardpermissions,
  twitterxpermissions,
  entitlementPermissions,
  intercomPermissions,
  mediarelationspermissions,
  companiespermissions,
  auth0permissions = [],
  groups,
  scriptRunnerv2Permissions = [],
) => {
  const AdminTools = [
    {
      target: "_blank",
      href: "/admin",
      startIcon: "actions:add",
      title: "GSD User Management",
      text: "Manage GSD user profiles",
      Buttontitle: "Users",
    },
    {
      target: "_blank",
      href: "/audit",
      startIcon: "actions:add",
      title: "GSD Usage Log",
      text: "90 Day lookback GSD Usage",
      Buttontitle: "Usage",
    },
  ];

  const objExplorer = [
    {
      href: "/companydetail",
      startIcon: "business",
      title: "Entitlements",
      required: "companyid",
      show: true,
    },
    {
      href: "/objectexplorer",
      startIcon: "code",
      text: "View JSON of Single Object",
      title: "Object Explorer",
      required: "companyid",
      show: permissions.includes("read"),
    },
  ];

  const mwTools = [
    {
      href: "/bounces",
      startIcon: "breakout_post",
      title: "Bounce/Suppressions",
      text: "Check and unblock Sengrid Users",
      Buttontitle: "SendGrid",
      required: "companyid,email",
      show: sendgridpermissions.includes("read"),
    },
    {
      href: "/customdashboard",
      startIcon: "business",
      title: "Dashboard Recovery",
      text: "Deleted within last 6 months",
      Buttontitle: "Dashboards",
      required: "companyid",
      show: dashboardpermissions.includes("write"),
    },
    {
      href: "/hc",
      startIcon: "mediatypes:x",
      title: "Twitter Historical Content",
      text: "Get historic tweets",
      Buttontitle: "Twitter Historical Content",
      show: twitterxpermissions.includes("write"),
    },
    {
      href: "/searches",
      startIcon: "csv",
      title: "Manage Explore",
      text: "Searches, Filters, Custom Categories",
      Buttontitle: "Searches",
      required: "companyid",
      show: permissions.includes("read"),
    },
    {
      href: "/jira",
      startIcon: "csv",
      title: "Jira",
      text: "Triton Jira Tool",
      Buttontitle: "Jira",
      show: permissions.includes("read") || permissions.includes("jira"),
    },
    {
      href: "/mediarelations",
      startIcon: "features:media_lists",
      title: "Media Relations",
      text: "Export and Copy Contact Lists",
      Buttontitle: "Media Relations",
      required: "companyid",
      show: mediarelationspermissions.includes("read"),
    },
    {
      href: "/companies",
      startIcon: "breakout_post",
      title: "Create Company",
      text: "Create Company & Initial User",
      Buttontitle: "Companies",
      show:
        companiespermissions.includes("write") ||
        companiespermissions.includes("admin"),
    },
    {
      href: "/script-runner",
      startIcon: "code",
      title: "Script Runner",
      text: "Script Runner",
      Buttontitle: "Script Runner",
      show:
        permissions.includes("admin") || companiespermissions.includes("admin"),
    },

    // Interns Script Runner Point
    {
      href: "/script-runner-V2",
      startIcon: "code",
      title: "Script Runner (Interns 2026)",
      text: "Script Runner(interns Project)",
      Buttontitle: "Script Runner",
      show:
        scriptRunnerv2Permissions.includes("read") 
    },
    {
      href: "/newsletter-unsubscribes",
      startIcon: "code",
      title: "Newsletter Unsubscribes",
      text: "Newsletter Unsubscribes",
      Buttontitle: "Newsletter Unsubscribes",
      show:
        permissions.includes("admin") || companiespermissions.includes("admin"),
    },
    {
      href: "/sendgrid/newsletters",
      startIcon: "csv",
      title: "Sendgrid status",
      text: "Monitor sendgrid blocks/bounces",
      Buttontitle: "Sendgrind",
      required: "companyid",
      show: permissions.includes("admin"),
    },
    {
      href: "/users-and-workspaces",
      startIcon: "csv",
      title: "Manage Users",
      text: "Exporting Users and Workspace Data",
      Buttontitle: "Users and workspaces",
      required: "companyid",
      show: permissions.includes("read"),
    },
    {
      href: "/dups",
      startIcon: "breakout_post",
      title: "Hamming distance",
      text: "Hamming distance for charikarLSH",
      Buttontitle: "Duplicate Docs",
      show: permissions.includes("admin"),
    },
    {
      href: "/sse",
      startIcon: "breakout_post",
      title: "Self-serve Entitlements",
      text: "Self-serve Entitlements",
      Buttontitle: "Self-serve Entitlements",
      show: true,
      // show: groups.includes('triton') || permissions.includes('admin'),
    },
    {
      href: "/intercom",
      startIcon: "actions:helpcenter",
      iconSrc: IntercomIcon,
      title: "Intercom",
      text: "Intercom",
      Buttontitle: "Intercom",
      // Temporarily disabled — re-enable by restoring the permission-based show below
      show: false,
      // show:
      //   intercomPermissions.includes("read") ||
      //   intercomPermissions.includes("write") ||
      //   intercomPermissions.includes("admin"),
      // show: groups.includes('triton') || permissions.includes('admin'),
    },
    {
      href: "/auth0-blocks",
      iconSrc: Auth0UnlockIcon,
      title: "Auth0 Unblock User",
      text: "Search and remove Auth0 user blocks",
      Buttontitle: "Auth0 Unblock",
      show:
        auth0permissions.includes("read") || auth0permissions.includes("admin"),
    },
    {
      href: '/user-lookup',
      startIcon: 'add_user_alert',
      title: 'User Lookup',
      text: 'Email ↔ User ID lookup',
      Buttontitle: 'User Lookup',
      show: permissions.includes('read'),
    },
    {
      href: "/intercom-v2/conversations",
      startIcon: "actions:helpcenter",
      iconSrc: IntercomIcon,
      title: "Intercom v2",
      text: "Intercom Search Conversations",
      Buttontitle: "Intercom v2",
      show:
        intercomPermissions.includes("read") ||
        intercomPermissions.includes("write") ||
        intercomPermissions.includes("admin"),
    },
  ];

  const IST_Tools = [
    {
      target: "_blank",
      href: "https://wc-prod-admin-ui.meltwater.io/",
      startIcon: "features:engage",
      title: "Wildcards Admin",
      text: "Engage Backfill Tool",
      Buttontitle: "Wildcards",
      show: permissions.includes("read"),
    },
    {
      target: "_blank",
      href: "https://app.meltwater.com/admin/support",
      startIcon: "history",
      title: "Legacy Support",
      text: "Legacy Support",
      Buttontitle: "Legacy",
      show: permissions.includes("read"),
    },
    {
      target: "_blank",
      href: "https://app.meltwater.com/masfsearch/tool/copy-searches",
      startIcon: "actions:duplicate",
      title: "Copy Searches",
      text: "Flamingo tool to copy searches",
      Buttontitle: "Searches",
      show: permissions.includes("read"),
    },
    {
      target: "_blank",
      href: "https://admin.notifications.meltwater.com/",
      startIcon: "add_user_alert",
      title: "Smart Alerts",
      text: "Smart Alerts tool",
      Buttontitle: "Searches",
      show: permissions.includes("read"),
    },
    {
      target: "_blank",
      href: "https://subscription-admin-tool.k8s-cobalt.internal.azure.meltwater.io/",
      startIcon: "features:engage",
      title: "Inception Tool (VPN needed)",
      text: "Subscription & Monitored connection info",
      Buttontitle: "Inception Tool",
      show: permissions.includes("read"),
    },
  ];

  return {
    AdminTools,
    objExplorer,
    mwTools,
    IST_Tools,
  };
};
